import { useNavigate } from 'react-router-dom';

const MenuSection = () => {
  const navigate = useNavigate();

  const menus = [
    {
      title: '痩身・ボディメイク',
      subtitle: 'Fit Carving',
      description: '筋力アップと脂肪燃焼を同時に',
      image: 'https://public.readdy.ai/ai/img_res/086dbed2f398f65a94245de6be4e36ad.jpg',
      path: '/menu#body',
    },
    {
      title: 'フェイシャル',
      subtitle: 'Revcella / プラズマ',
      description: '毛穴・くすみ・ハリツヤにアプローチ',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20facial%20treatment%20with%20plasma%20device%2C%20woman%20receiving%20advanced%20facial%20therapy%2C%20glowing%20skin%20care%2C%20professional%20esthetician%20performing%20treatment%2C%20modern%20beauty%20technology%2C%20clean%20white%20background%2C%20elegant%20spa%20atmosphere%2C%20high-end%20skincare%20equipment%2C%20serene%20and%20professional%20setting&width=800&height=800&seq=menu-facial-001&orientation=squarish',
      path: '/menu#facial',
    },
    {
      title: '頭皮ケア＆育毛',
      subtitle: 'MOUMITU + LED',
      description: '薄毛予防・ボリュームアップ',
      image: 'https://readdy.ai/api/search-image?query=Professional%20scalp%20care%20treatment%20with%20LED%20therapy%2C%20head%20spa%20massage%20with%20growth%20factor%20serum%2C%20relaxing%20hair%20treatment%2C%20modern%20beauty%20salon%2C%20clean%20white%20background%2C%20elegant%20equipment%2C%20woman%20receiving%20scalp%20therapy%2C%20peaceful%20spa%20environment%2C%20hair%20volume%20improvement%20treatment&width=800&height=800&seq=menu-scalp-001&orientation=squarish',
      path: '/menu#scalp',
    },
    {
      title: 'LED光トリートメント',
      subtitle: 'WellTerra',
      description: '顔・デコルテ・全身ケア',
      image: 'https://readdy.ai/api/search-image?query=LED%20light%20therapy%20dome%20treatment%2C%20woman%20relaxing%20under%20LED%20beauty%20device%2C%20colorful%20therapeutic%20lights%2C%20modern%20wellness%20technology%2C%20clean%20white%20spa%20room%2C%20futuristic%20beauty%20equipment%2C%20peaceful%20treatment%20atmosphere%2C%20full%20body%20light%20therapy%2C%20simple%20white%20background&width=800&height=800&seq=menu-led-001&orientation=squarish',
      path: '/menu#led',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-light-gold to-white px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-semibold text-center text-dark-gray mb-12 md:mb-16">
          メニュー
        </h2>
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {menus.map((menu, index) => (
            <div
              key={index}
              onClick={() => navigate(menu.path)}
              className="relative rounded-2xl md:rounded-3xl overflow-hidden cursor-pointer group aspect-[3/4]"
            >
              <div className="w-full h-full">
                <img
                  src={menu.image}
                  alt={menu.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 text-white">
                <p className="text-xs md:text-sm font-light mb-1 opacity-90">{menu.subtitle}</p>
                <h3 className="text-base md:text-xl font-bold mb-1 md:mb-2">{menu.title}</h3>
                <p className="text-xs md:text-sm font-light opacity-80">{menu.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
